import { getDocument } from '../../../utils/getDocument';
import { getIsMobile } from '../../../utils/getIsMobile';
import { DEFAULT_DOCUMENT_HEIGHT, DEFAULT_DOCUMENT_WIDTH } from '../../constants';
import { HEADER_HEIGHT } from '../../dashboard/DashboardHeader';
import { MOBILE_FOOTER_HEIGHT } from '../../dashboard/DashboardLayout';
import { CONTENT_ADAPTIVE_WIDTH_SCALE } from '../../dashboard/constants';
import { PostUI } from '../types';
import { DESKTOP_MIN_POST_HEIGHT, DESKTOP_TEXT_WIDTH } from './constants';

export const makeMediaParams = (post: PostUI, index: number) => ({
    mediaId: post.content[index].id,
    mediaIndex: index,
});

export const getRatio = (post: PostUI) => {
    const [firstContent] = post.content;

    return Math.min(
        (firstContent?.media[0]?.width || 1) / (firstContent?.media[0]?.height || 1),
        1,
    );
};

const MAX_POST_HEIGHT_DESKTOP_FROM_VIEW_PERCENT = 0.8;
const MAX_POST_HEIGHT_MOBILE_OFFSET = HEADER_HEIGHT + MOBILE_FOOTER_HEIGHT;

export const getCarouselSizes = (
    post: PostUI,
    params?: { horizontalText?: boolean; maxHeight?: number; maxWidth?: number },
) => {
    const {
        horizontalText = true,
        maxHeight: forceMaxHeight,
        maxWidth: forceMaxWidth,
    } = params || {};
    const ratio = getRatio(post);
    let largestMedia = post.content[0].media[0];

    post.content[0].media.forEach((media) => {
        if (media.width > largestMedia.width) {
            largestMedia = media;
        }
    });

    const docHeight = getDocument()?.documentElement.clientHeight || DEFAULT_DOCUMENT_HEIGHT;
    const docWidth = getDocument()?.documentElement.clientWidth || DEFAULT_DOCUMENT_WIDTH;
    const { isMobile } = getIsMobile();

    if (isMobile) {
        let height = largestMedia.height;
        let width = height * ratio;
        // Чтобы получать квадратные посты в случае горизонтального контента

        const maxHeight = docHeight - MAX_POST_HEIGHT_MOBILE_OFFSET;
        const newWidth = docWidth;
        width = newWidth;
        height = newWidth / ratio;

        if (height > maxHeight) {
            height = maxHeight;
        }

        return {
            width,
            height,
        };
    }

    let height = largestMedia.height;
    // Чтобы получать квадратные посты в случае горизонтального контента
    let width = height * ratio;

    let maxHeight = MAX_POST_HEIGHT_DESKTOP_FROM_VIEW_PERCENT * docHeight;

    if (forceMaxHeight) {
        maxHeight = Math.min(maxHeight, forceMaxHeight);
    }
    let maxWidth =
        (CONTENT_ADAPTIVE_WIDTH_SCALE / 100) * docWidth - (horizontalText ? DESKTOP_TEXT_WIDTH : 0);

    if (forceMaxWidth) {
        maxWidth = Math.min(maxWidth, forceMaxWidth);
    }

    if (height > maxHeight) {
        const newHeight = maxHeight;

        height = newHeight;
        width = newHeight * ratio;
    }

    if (width > maxWidth) {
        const newWidth = maxWidth;

        width = newWidth;
        height = newWidth / ratio;
    }

    if (height < DESKTOP_MIN_POST_HEIGHT) {
        const newHeight = DESKTOP_MIN_POST_HEIGHT;

        height = newHeight;
        width = newHeight * ratio;
    }

    return {
        width,
        height,
    };
};
